var React = require('react');

function ArrowFromTop (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M24 32h336a23.94 23.94 0 0 1 24 24v16a23.94 23.94 0 0 1-24 24H24A23.94 23.94 0 0 1 0 72V56a23.94 23.94 0 0 1 24-24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M327.87 286.52l17.06 17a23.86 23.86 0 0 1 0 33.91L209 473a24 24 0 0 1-34 0L39.07 337.43a23.86 23.86 0 0 1 0-33.91l17.06-17a24 24 0 0 1 34 0l65.81 65.61V152A24 24 0 0 1 180 128h24.08a24 24 0 0 1 24.07 24v200.13L294 286.52a23.9 23.9 0 0 1 33.87 0z","className":"fa-primary","key":2})]);
}

ArrowFromTop.defaultProps = {"viewBox":"0 0 384 512","className":"icon"};

module.exports = ArrowFromTop;

ArrowFromTop.default = ArrowFromTop;
